/**
 * Redirect to Category page searchUrl (search page result)
 * @param {string} searchUrl
 * @param {string} category
 */

function redirectToCategorySearch (searchUrl, category) {

	const adjustedSearchUrl = searchUrl.replace('#', '');
	const categorySearchUrl = category ? `${category}/` : '';
	const searchPartialUrl = `/products/${categorySearchUrl}${adjustedSearchUrl}?s=1`;

	// redirect to search result page
	window.location.href = searchPartialUrl;

}

export default redirectToCategorySearch;
